var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytes, FctValue, FctValue24, FctValue160, isVariable } from '../../../../Fct/generics';
import { getSupportedTokens } from '../../../../Fct/plugins/allowanceRequiredProtocols';
import { SWAP_ROUTER_02_ADDRESSES } from '../helpers/constants';
export var SimpleSwapExactOutputSwapRouter02 = createPlugin({
    protocol: 'UNISWAP_V3',
    type: 'ACTION',
    method: 'exactOutput',
    name: 'simpleSwapExactOutputV3SwapRouter02',
    supportedContracts: SWAP_ROUTER_02_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                tokenIn: new FctAddress({ mode: 'INPUT', destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                tokenOut: new FctAddress({ mode: 'INPUT', destination: 'erc20', options: getSupportedTokens({ chainId: chainId }) }),
                amountIn: new FctValue({ readonly: true, destination: 'wei_amount', required: false }),
                amountOut: new FctValue({ mode: 'INPUT', destination: 'wei_amount' }),
                methodParams: {
                    params_tuple: {
                        tokenIn: new FctAddress({
                            required: false,
                            readonly: true,
                            destination: 'erc20',
                            options: getSupportedTokens({ chainId: chainId }),
                        }),
                        tokenOut: new FctAddress({
                            required: false,
                            readonly: true,
                            destination: 'erc20',
                            options: getSupportedTokens({ chainId: chainId }),
                        }),
                        fee: new FctValue24({ required: false, readonly: true }),
                        path: new FctBytes({ required: false, readonly: true }),
                        recipient: new FctAddress({ mode: 'INPUT' }),
                        amountOut: new FctValue({ readonly: true, destination: 'wei_amount' }),
                        amountInMaximum: new FctValue({ destination: 'wei_amount' }),
                        sqrtPriceLimitX96: new FctValue160({ required: false }),
                    },
                },
            },
            output: {
                amountIn: new FctValue({}),
            },
        });
    },
    initParams: {
        methodParams: {
            params_tuple: {
                sqrtPriceLimitX96: '0',
            },
        },
    },
    overrideSetMethodParams: function (_a) {
        var input = _a.input;
        return function (params, method) {
            var params_tuple = input.methodParams.params_tuple;
            if (method === 'exactOutput') {
                params_tuple.path.value = params[0];
                params_tuple.recipient.value = params[1];
                params_tuple.amountOut.value = params[2];
                input.amountOut.value = params[2];
                params_tuple.amountInMaximum.value = params[3];
            }
            if (method === 'exactOutputSingle') {
                params_tuple.tokenIn.value = params[0];
                params_tuple.tokenOut.value = params[1];
                params_tuple.fee.value = params[2];
                params_tuple.recipient.value = params[3];
                params_tuple.amountOut.value = params[4];
                input.amountOut.value = params[4];
                params_tuple.amountInMaximum.value = params[5];
                params_tuple.sqrtPriceLimitX96.value = params[6];
            }
        };
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, setMethod = _a.setMethod;
        var getPathParams = function (_a) {
            var service = _a.service;
            return __awaiter(void 0, void 0, void 0, function () {
                var tokenInAddress, tokenOutAddress, defaultReturn, amountOut, getAmount, amount, isSimulationNeeded, decimalsOut, res, _b, tokenIn, tokenOut, fee, sqrtPriceLimitX96, path, _c, amountInMaximum_1, recipient_1, rest_1, _d, amountInMaximum, recipient, rest, e_1;
                var _e, _f;
                return __generator(this, function (_g) {
                    switch (_g.label) {
                        case 0:
                            tokenInAddress = input === null || input === void 0 ? void 0 : input.tokenIn.value;
                            tokenOutAddress = input === null || input === void 0 ? void 0 : input.tokenOut.value;
                            defaultReturn = {
                                params: {
                                    amountIn: undefined,
                                    methodParams: {
                                        params_tuple: {
                                            tokenIn: undefined,
                                            tokenOut: undefined,
                                            path: undefined,
                                            amountInMaximum: undefined,
                                            amountOut: undefined,
                                        },
                                    },
                                },
                                error: undefined,
                            };
                            if (!tokenInAddress ||
                                !tokenOutAddress ||
                                typeof tokenInAddress !== 'string' ||
                                typeof tokenOutAddress !== 'string')
                                return [2 /*return*/, defaultReturn];
                            amountOut = input === null || input === void 0 ? void 0 : input.amountOut;
                            getAmount = function () {
                                if (isVariable(amountOut.value) && amountOut.estimatedValue && amountOut.estimatedValue !== '0') {
                                    return amountOut.estimatedValue;
                                }
                                return amountOut.value;
                            };
                            amount = getAmount();
                            if (amount === undefined)
                                return [2 /*return*/, defaultReturn];
                            isSimulationNeeded = false;
                            if (!amount || isVariable(amount)) {
                                isSimulationNeeded = true;
                                decimalsOut = ((_e = input.amountOut) === null || _e === void 0 ? void 0 : _e.decimals) !== undefined ? (_f = input.amountOut) === null || _f === void 0 ? void 0 : _f.decimals : 18;
                                amount = '1' + '0'.repeat(decimalsOut);
                            }
                            _g.label = 1;
                        case 1:
                            _g.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, service.create({
                                    cmd: 'simulateSwap',
                                    protocol: 'uniswap',
                                    token_in: tokenInAddress,
                                    token_in_decimals: 0,
                                    token_out: tokenOutAddress,
                                    token_out_decimals: 0,
                                    token_amount: amount,
                                    type: 'out',
                                    version: 'v3',
                                })];
                        case 2:
                            res = (_g.sent());
                            if (!res) {
                                return [2 /*return*/, {
                                        params: {
                                            amountIn: undefined,
                                            methodParams: { params_tuple: { path: undefined, amountInMaximum: undefined } },
                                        },
                                        error: 'invalid trade',
                                    }];
                            }
                            _b = input.methodParams.params_tuple, tokenIn = _b.tokenIn, tokenOut = _b.tokenOut, fee = _b.fee, sqrtPriceLimitX96 = _b.sqrtPriceLimitX96, path = _b.path;
                            if (!res.params) {
                                return [2 /*return*/, {
                                        params: {
                                            amountIn: undefined,
                                            methodParams: { params_tuple: { path: undefined, amountInMaximum: undefined } },
                                        },
                                        error: 'invalid trade',
                                    }];
                            }
                            if (res.name === 'exactOutputSingle') {
                                if (setMethod)
                                    setMethod('exactOutputSingle');
                                tokenIn.virtual = false;
                                tokenOut.virtual = false;
                                fee.virtual = false;
                                sqrtPriceLimitX96.virtual = false;
                                path.virtual = true;
                                _c = res === null || res === void 0 ? void 0 : res.params, amountInMaximum_1 = _c.amountInMaximum, recipient_1 = _c.recipient, rest_1 = __rest(_c, ["amountInMaximum", "recipient"]);
                                return [2 /*return*/, {
                                        params: {
                                            amountIn: amountInMaximum_1,
                                            methodParams: {
                                                params_tuple: __assign(__assign({}, rest_1), { amountInMaximum: amountInMaximum_1 }),
                                            },
                                        },
                                        isSimulationNeeded: isSimulationNeeded,
                                        error: undefined,
                                    }];
                            }
                            if (res.name !== 'exactOutput') {
                                return [2 /*return*/, {
                                        params: {
                                            amountIn: undefined,
                                            methodParams: { params_tuple: { path: undefined, amountOutMinimum: undefined } },
                                        },
                                        error: 'invalid trade',
                                    }];
                            }
                            if (setMethod)
                                setMethod('exactOutput');
                            tokenIn.virtual = true;
                            tokenOut.virtual = true;
                            fee.virtual = true;
                            sqrtPriceLimitX96.virtual = true;
                            path.virtual = false;
                            _d = res === null || res === void 0 ? void 0 : res.params, amountInMaximum = _d.amountInMaximum, recipient = _d.recipient, rest = __rest(_d, ["amountInMaximum", "recipient"]);
                            return [2 /*return*/, {
                                    params: {
                                        amountIn: amountInMaximum,
                                        methodParams: {
                                            params_tuple: __assign(__assign({}, rest), { amountInMaximum: amountInMaximum }),
                                        },
                                    },
                                    isSimulationNeeded: isSimulationNeeded,
                                    error: undefined,
                                }];
                        case 3:
                            e_1 = _g.sent();
                            return [2 /*return*/, {
                                    params: {
                                        amountIn: undefined,
                                        methodParams: { params_tuple: { path: undefined, amountInMaximum: undefined } },
                                    },
                                    error: e_1.message,
                                }];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        return { get: getPathParams, depParamKeys: ['tokenIn', 'tokenOut', 'amountOut'] };
    },
    requiredApprovals: function (params, _chainId, _walletAddress, _vaultAddress, _provider, _method, isEstimation) {
        var tokenIn = params.tokenIn;
        if (!tokenIn.value || typeof tokenIn.value !== 'string')
            return [];
        var tokenToApprove = tokenIn.value;
        var amountParam = params === null || params === void 0 ? void 0 : params.methodParams['params_tuple'].amountInMaximum;
        var getAmount = function () {
            if (isEstimation) {
                if (isVariable(amountParam.value)) {
                    return amountParam.estimatedValue;
                }
            }
            return amountParam.value;
        };
        return [
            {
                to: tokenToApprove,
                params: { spender: params === null || params === void 0 ? void 0 : params.to.value, amount: getAmount() },
                method: 'approve',
                protocol: 'ERC20',
            },
        ];
    },
    getSubscribtions: function (_a) { return [
        {
            callback: function (params) {
                if (!params)
                    return;
                if (!params.amountOut.value)
                    return;
                params.methodParams.params_tuple.amountOut.setQuiet({ value: params.amountOut.value });
                return;
            },
            id: 'set_amount_by_amountOut_id',
        },
    ]; },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var to = params.to, amountIn = params.amountIn, amountOut = params.amountOut, tokenIn = params.tokenIn, tokenOut = params.tokenOut;
        if (!to.value || !amountIn.value || !amountOut.value || !tokenIn.value || !tokenOut.value || !vaultAddress)
            return [];
        if (typeof to.value !== 'string' ||
            typeof amountIn.value !== 'string' ||
            typeof amountOut.value !== 'string' ||
            typeof tokenIn.value !== 'string' ||
            typeof tokenOut.value !== 'string')
            return [];
        return [
            {
                address: vaultAddress,
                toSpend: [
                    {
                        token: tokenIn.value,
                        amount: amountIn.value,
                    },
                ],
                toReceive: [
                    {
                        token: tokenOut.value,
                        amount: amountOut.value,
                    },
                ],
            },
        ];
    },
    // onCreate: ({ input }) => {
    //   const setAmountOut = () => {
    //     input.methodParams.params_tuple.amountOut.set({ value: input.amountOut.value })
    //   }
    //   input.amountOut.subscribe({
    //     callback: () => {
    //       setAmountOut()
    //     },
    //     id: 'set amount by amountIn',
    //   })
    //   setAmountOut()
    // },
});
